import moment from 'moment';
import HuaweiErrors from '../../../../controllers/HuaweiErrors';
import { NotFoundError } from '../../../../errors/not-found-error';
import { PlayResult } from '../../../../interfaces';
import { SingleRecording } from '../../recordings/types/recording';
import { PlayData, startSession } from '../api';
import { handlePlayResult } from './handle-play-result';
import { client } from './huawei-client';

export async function playRecording(recording: SingleRecording, shouldStartSession = true): Promise<PlayData> {
  const data = await client.post<PlayResult>('/EPG/JSON/Play', {
    pvrId: recording.id,
    contentid: recording.programId,
    playtype: 9, // npvr type
    mediaid: recording.mediaId,
  });

  if (data.retcode === HuaweiErrors.PVR_NOT_FOUND) {
    throw new NotFoundError('Recording not found');
  }

  const result = handlePlayResult(data);

  let sessionId = 'N/A';

  if (shouldStartSession) {
    const duration = moment(recording.endTime).diff(recording.startTime, 'seconds');

    sessionId = await startSession({
      duration: duration,
      platformTitleId: recording.programId,
      providerIdentifier: recording.channelId,
    });
  }

  const trigger = result.triggers[0].getLicenseTrigger;

  return {
    status: true,
    platform: 'huawei',
    url: result.url,
    message: '',
    licenseUrl: trigger.licenseURL,
    token: trigger.customData,
    sessionId: sessionId,
    releasePid: '',
    account: '',
    mediaId: recording.mediaId,
  };
}
